module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.fileSearchLoading && _vm.paymentLoading) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "role": "warning"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Please wait while we process your File Search for payment.\n                        This may take a few minutes. Please do not close this window or click the back button.\n                    ")]), _vm._v(" "), (_vm.trsProcessing) ? _c('div', {
    staticClass: "my-3",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "mb-1",
    staticStyle: {
      "font-weight": "bold",
      "color": "#364760"
    }
  }, [_vm._v(_vm._s(_vm.trsProcessText))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated",
    style: ({
      width: _vm.trsProcessPercent + '%'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.trsProcessPercent,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.trsProcessPercent) + "%\n                                ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../img/loading-black.gif")
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fileSearchLoading && !_vm.trsProcessing) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.fileSearchLoading) ? _c('div', [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "File Search"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', [_c('media', {
    ref: "media",
    attrs: {
      "mediaTypeId": _vm.mediaTypeId,
      "parentId": _vm.fileSearchId,
      "formDisabled": _vm.formDisabled
    },
    on: {
      "mediaRefreshComplete": function($event) {
        _vm.handleMediaRefreshComplete()
      },
      "mediaRefreshStarted": function($event) {
        _vm.handleMediaRefreshStarted()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('hr')]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "form-horizontal"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    on: {
      "savePlss": _vm.savePlssFileSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasFieldworkRequest && !_vm.formDisabled) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.copyFwrPlss()
      }
    }
  }, [_vm._v("Copy Fieldwork Request\n                                    PLSS Locations")])]) : _vm._e(), _vm._v(" "), (_vm.hasE106Compliance && !_vm.formDisabled) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.copyE106Plss()
      }
    }
  }, [_vm._v("Copy E106 Compliance\n                                    PLSS Locations")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.plssLocationGridSpec.tableData.length > 0),
      expression: "plssLocationGridSpec.tableData.length > 0"
    }]
  }, [_c('h4', [_vm._v("Section List")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row.fileSearchPlssLocationId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.canPlaceOrder) ? _c('div', [_c('h4', [_vm._v("Submission")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.mediaRefreshing,
      "name": "button2",
      "type": "submit"
    },
    on: {
      "click": _vm.goPayment
    }
  }, [_vm._v("Place Order")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.canPlaceOrder),
      expression: "!canPlaceOrder"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.containsWindRiver) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }, [_vm._v(" ")]), _c('strong', [_vm._v("Please Note:")]), _vm._v(" This file\n                                        search requests data from the Wind River meridian. "), _c('strong', [_vm._v("The request will\n                                            need to be reviewed by SHPO.")])]) : _vm._e(), _vm._v(" "), (_vm.isLargeFileSearches) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }, [_vm._v(" ")]), _c('strong', [_vm._v("Please Note:")]), _vm._v(" This file\n                                        search contains over " + _vm._s(_vm.largeFsCutOff) + " sections. "), _c('strong', [_vm._v("The request will\n                                            need to be reviewed by SHPO.")])]) : _vm._e()])])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Files"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "files"
    }
  }, [_c('mediaLetter', {
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdFsLetter,
      "parentId": _vm.fileSearchId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('mediaFileSearchReport', {
    ref: "mediaFileSearchReport",
    attrs: {
      "parentId": _vm.fileSearchId,
      "fileSearchComplete": _vm.fileSearchComplete
    }
  })], 1), _vm._v(" "), (_vm.fileSearchComplete) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h4', [_vm._v("File Search Sites")]), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.crGridSpec.tableData,
      "columns": _vm.crGridSpec.columns,
      "options": _vm.crGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.culturalResourceId) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/CulturalResource/' + props.row.culturalResourceId
            },
            "tag": "a"
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (this.crGridSpec.tableDataTcp.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Tribal Cultural Properties")]), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.crGridSpec.tableDataTcp,
      "columns": _vm.crGridSpec.columns,
      "options": _vm.crGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.culturalResourceId) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/CulturalResource/' + props.row.culturalResourceId
            },
            "tag": "a"
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.canGetZip && _vm.zipFileAlertHidden && !_vm.restrictedOrganizationRole) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.getSiteZip
    }
  }, [_vm._v("Get Shapefiles")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "width": "99%"
    }
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible",
    class: {
      'hidden': _vm.zipFileAlertHidden
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                                    Zip file is being generated. It will be downloaded to your browser's Downloads\n                                    folder in a few moments.\n                                ")])])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Map"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeId,
      "parentId": _vm.fileSearchId,
      "loadOnMount": false
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.fileSearchWorkflowId,
      "parentId": _vm.fileSearchId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.paymentReceipt) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "button3",
      "type": "submit"
    },
    on: {
      "click": _vm.goPaymentReceipt
    }
  }, [_vm._v("Payment\n                                Receipt")]) : _vm._e(), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.project.projectId,
      "fileSearchId": _vm.fileSearch.fileSearchId,
      "mediaTypeId": _vm.mediaTypeIdFsLetter,
      "parentId": _vm.fileSearchId
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Validation errors: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errors))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("fileSearch: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.fileSearch))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("PlaceOrder: ")]), _vm._v(" "), _c('pre', [_vm._v("canPlaceOrder: " + _vm._s(_vm.canPlaceOrder))]), _vm._v(" "), _c('pre', [_vm._v("sectionCount: " + _vm._s(_vm.sectionCount))]), _vm._v(" "), _c('pre', [_vm._v("containsWindRiver " + _vm._s(_vm.containsWindRiver))]), _vm._v(" "), _c('pre', [_vm._v("status " + _vm._s(this.currentWorkflowStatus.workflowStatusDescription))]), _vm._v(" "), _c('pre', [_vm._v("is approved " + _vm._s((this.currentWorkflowStatus.workflowStatusDescription === 'Approved') ? 'Yes' : 'No'))])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("File Search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1717fc32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FileSearch.vue
// module id = 902
// module chunks = 1